export const getLengthFromAxis = (axis) => (axis === 'y' ? 'height' : 'width');
